import React, { useState } from "react";
import { Outlet, useLocation, Navigate } from "react-router-dom";
import Navigation from "./Navigation";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../store/slices/authSlice";
import TwoFactorNudge from "../settings/TwoFactorNudge";
import ResolvedIssuesNotifier from "../notifications/ResolvedIssuesNotifier";

/** Paths a properties-only PA is allowed to access (property-related only). */
const isPropertiesOnlyPAAllowedPath = (pathname) =>
  pathname.startsWith("/properties") ||
  pathname.startsWith("/property/") ||
  pathname.startsWith("/collings-properties") ||
  pathname.startsWith("/public-property-search") ||
  pathname.startsWith("/collings-data-properties") ||
  pathname === "/add-property";

const MainLayout = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { user } = useSelector((state) => state.auth);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const isPropertiesOnlyPA = user?.role === "pa" && user?.pa_access_level === "properties_only";
  const allowed = isPropertiesOnlyPAAllowedPath(location.pathname);
  if (isPropertiesOnlyPA && !allowed) {
    return <Navigate to="/properties" replace />;
  }

  const toggleCollapse = () => setIsCollapsed((prev) => !prev);
  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <div className="flex min-h-screen bg-gray-50">
      {/* Left Sidebar Navigation */}
      <Navigation
        currentUser={user}
        onLogout={handleLogout}
        isCollapsed={isCollapsed}
        toggleCollapse={toggleCollapse}
        setIsCollapsed={setIsCollapsed}
        isMobileMenuOpen={isMobileMenuOpen}
        setIsMobileMenuOpen={setIsMobileMenuOpen}
      />
      {/* Main Content */}
      <div
        className={`flex-1 flex flex-col min-h-screen min-w-0 transition-all duration-300 ${isCollapsed ? "md:pl-20" : "md:pl-64"
          }`}
      >
        <div className="flex-1 overflow-x-hidden p-3 sm:p-4 md:p-6 pt-[3.5rem] sm:pt-[3.75rem] md:pt-6">
          <Outlet />
        </div>
      </div>
      {/* Post-login prompt encouraging staff to enable 2FA (opt-in) */}
      <TwoFactorNudge />
      {/* Non-blocking corner card: tells a reporter when an issue they raised
          has been resolved (set to For/Agents to Review on Monday). */}
      <ResolvedIssuesNotifier />
    </div>
  );
};

export default MainLayout;
